const isOrderAssignedToUser = (uid, order) => {
  return uid === (order && order.ticketAssignedToUserId);
};

export default isOrderAssignedToUser;



// WEBPACK FOOTER //
// ../utils/functions/is-order-assigned-to-user.js